import analyticsRoutes from '@/modules/analytics/router'
import dashboardRoutes from '@/modules/dashboard/router'
import campaignRoutes from '@/modules/campaign-manage/router'
import campaignsRoutes from '@/modules/campaigns/router'
import profilesRoutes from '@/modules/profiles/router'
import yiiRoutes from '@/core/router/yii-routes'
import eventsRoutes from '@/modules/events/router'
import metricsRoutes from '@/modules/metrics/router'
import projectRoutes from '@/modules/project/router'
import settingsRoutes from '@/modules/settings/router'
import alarmsRoutes from '@/modules/alarms/router'
import attributionRoutes from '@/modules/attribution/router'
import tasksRoutes from '@/modules/tasks/router'
import testsRouter from '@/modules/tests/router'
import impressionsRoutes from '@/modules/impressions/router'
import channelsRoutes from '@/modules/channels/router'
import snippetsRoutes from '@/modules/snippets/router'
import sitesRoutes from '@/modules/sites/router'
import emailSavedRowsRoutes from '@/modules/email-saved-rows/router'
import notificationsLogRoutes from '@/modules/notifications-log/router'
import listsRoutes from '@/modules/lists/router'
import audienceRoutes from '@/modules/audiences/router'
import integrationsRoutes from '@/modules/integrations/router'
import devicesRoutes from '@/modules/devices/router'
import dataManagerRoutes from '@/modules/data-manager/router'
import errorsRoutes from '@/modules/errors/router'
import accountRoutes from '@/modules/account/router'
import automationsRoutes from '@/modules/automations/router'
import importRoutes from '@/modules/imports/router'
import customerIntelligenceRoutes from '@/modules/customer-intelligence/router'
import metabaseRoutes from '@/modules/metabase/router'
import templatesRoutes from '@/modules/templates/router'
import auditLogRoutes from '@/modules/audit-log/router'
import seedListRoutes from '@/modules/seed-list/router'
import mlStudioRoutes from '@/modules/ml-studio/router'
import gamificationRoutes from '@/modules/gamification/router'
import consentManagerRoutes from '@/modules/consent-manager/router'
import systemRoutes from '@/modules/system/router'

export default [
  ...analyticsRoutes,
  ...dashboardRoutes,
  ...campaignRoutes,
  ...campaignsRoutes,
  ...accountRoutes,
  ...profilesRoutes,
  ...yiiRoutes,
  ...eventsRoutes,
  ...metricsRoutes,
  ...projectRoutes,
  ...settingsRoutes,
  ...alarmsRoutes,
  ...attributionRoutes,
  ...tasksRoutes,
  ...testsRouter,
  ...impressionsRoutes,
  ...channelsRoutes,
  ...tasksRoutes,
  ...notificationsLogRoutes,
  ...listsRoutes,
  ...audienceRoutes,
  ...integrationsRoutes,
  ...devicesRoutes,
  ...snippetsRoutes,
  ...sitesRoutes,
  ...emailSavedRowsRoutes,
  ...dataManagerRoutes,
  ...automationsRoutes,
  ...importRoutes,
  ...customerIntelligenceRoutes,
  ...metabaseRoutes,
  ...errorsRoutes,
  ...templatesRoutes,
  ...auditLogRoutes,
  ...seedListRoutes,
  ...mlStudioRoutes,
  ...gamificationRoutes,
  ...consentManagerRoutes,
  ...systemRoutes
]



// WEBPACK FOOTER //
// ./src/core/router/routes.js